module.exports = __webpack_public_path__ + "img/_waermeschutz.dd569106.svg";